import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {UserRoleService} from '../../../shared/service/userrole.service';
import {UserRoleModel} from '../../../shared/dto/user-role.model';
import {UserroleCategoryService} from '../../../shared/service/userrole-category.service';
import {UserRoleCategoryModel} from '../../../shared/dto/user-role-category.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserRolePopupComponent} from './user-role-popup/user-role-popup.component';
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import swal from "sweetalert2";
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-user-roles',
  templateUrl: './user-roles.component.html',
  styleUrls: ['./user-roles.component.scss']
})
export class UserRolesComponent implements OnInit {
  public userRoleForm: FormGroup;
  public userRoles: UserRoleModel [] = [];
  public userRoleCategories: UserRoleCategoryModel [] = [];
  public userRoleConfigItems: UserRoleModel[] = [];
  public href: string = "";

  constructor(private userRoleService: UserRoleService,
              private userroleCategoryService: UserroleCategoryService,
              public modalService: NgbModal,
              public tokenStorageService: TokenStorageService,
              private spinnerService: NgxUiLoaderService,
              private router : Router) { }

  ngOnInit() {
    this.userRoleForm = new FormGroup({
      userRoleCategory: new FormControl(null),
      userRoleCode: new FormControl(null),
      states: new FormControl(null),
    });
    this.href = this.router.url;
    this.onLoadGetData();
    this.loadUserRoles();
    this.loadUserRoleCategories();
  }

  loadUserRoles() {
    this.userRoleService.getAllUserRoles().subscribe(
      (data: UserRoleModel[]) => {
        this.userRoleConfigItems = data;
        this.userRoles = data;
      }
    );
  }

  loadUserRoleCategories() {
    this.userroleCategoryService.getAllUserRoleCategory().subscribe(
      (data: UserRoleCategoryModel[]) => {
        this.userRoleCategories = data;
      }
    )
  }

  onClickNew() {
    const modalRef = this.modalService.open(UserRolePopupComponent, {
      windowClass: 'xlModal'
    });
    modalRef.componentInstance.name = 'Add New User Role';
    modalRef.componentInstance.selectedMode = ActionMode.ADD;
    modalRef.componentInstance.userRoleMgtCopy_ = this.userRoleConfigItems;
    modalRef.result.then((data: string) => {
      if (data == 'Saved') {
       this.onLoadGetData();
       this.loadUserRoles();
       this.loadUserRoleCategories();
      }
    }, () => {

    });
  }

  onLoadGetData(): void {
    const userRoleModel = new UserRoleModel(
      null,
      null,
     null,
      null,
      null,
      null,
      null);

    this.loadSearchResultList(userRoleModel);
  }

  loadSearchResultList(userRoleModel: UserRoleModel): void {
    this.spinnerService.start();
    this.userRoleService.getSearchResult(userRoleModel).subscribe(
      (data: UserRoleModel[]) => {
        this.userRoleConfigItems = data;
      },
      (error) => {
        this.spinnerService.stop();
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        this.spinnerService.stop();
        if (this.userRoleConfigItems == null || this.userRoleConfigItems.length === 0) {
          swal.fire('Sorry', 'No result found.', 'error');
          this.loadUserRoles();
        } else {
          this.userRoleService.clearUserRoleSearchDetails();
          this.userRoleService.setUserRoleSearchDetails(
            this.userRoleConfigItems
          );
        }
      }
    );
  }

  validateAllFormFields(formGroup: FormGroup) {

    Object.keys(formGroup.controls).forEach(field => {

      const control = formGroup.get(field);
      if (control instanceof FormControl) {

        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {

        this.validateAllFormFields(control);
      }
    });
  }

  onSubmitSearch(): void {
    let isValid: boolean = false;
    let msg: string = 'Please fill the form..!';

    if (this.userRoleForm.value.userRoleCategory != null) {
      isValid = true;
    }
    if (this.userRoleForm.value.userRoleCode != null) {
      isValid = true;
    }
    if (this.userRoleForm.value.states != null) {
      isValid = true;
    }
    if (isValid && this.userRoleForm.valid) {
      const userRoleSearchDetails = new UserRoleModel(
        this.userRoleForm.value.userRoleCode,
        null,
        this.userRoleForm.value.states,
        this.userRoleForm.value.userRoleCategory,
        null,
        this.tokenStorageService.getUserObjectToken().username,
        this.href
      );
      this.loadSearchResultList(userRoleSearchDetails);
      this.spinnerService.start();
    } else {
      this.validateAllFormFields(this.userRoleForm);
      swal.fire('Error', msg, 'error');
    }
  }

  onClickReset(): void {
    this.userRoleForm.reset({
      userRoleCode: null,
      userRoleCategory: null,
    });
    this.onLoadGetData();
  }
}
